import { inject, Injectable, signal } from '@angular/core';
import { Observable, of, shareReplay, tap } from 'rxjs';
import { ConsentStatusDto } from '../api/v1/consents/consents.model';
import { ConsentService } from '../api/v1/consents/consents.service';

/**
 * Cache dello stato dei consensi dell'utente corrente.
 * Serve al guard, che altrimenti farebbe una GET a ogni navigazione: nella booking-web
 * non esiste uno store del profilo e ogni componente ricarica per conto proprio.
 */
@Injectable({
  providedIn: 'root',
})
export class ConsentStore {
  private readonly consentService = inject(ConsentService);

  readonly status = signal<ConsentStatusDto | null>(null);

  private inFlight: Observable<ConsentStatusDto> | null = null;

  load(): Observable<ConsentStatusDto> {
    const cached = this.status();

    if (cached) return of(cached);

    this.inFlight ??= this.consentService.getStatus().pipe(
      tap((status) => {
        this.status.set(status);
        this.inFlight = null;
      }),
      shareReplay(1),
    );

    return this.inFlight;
  }

  invalidate(): void {
    this.status.set(null);
    this.inFlight = null;
  }
}
